import Vue from 'vue'
import Vuex from 'vuex'
import widgets from './modules/widgets'
import search from './modules/search'
import analy from './modules/analysis'
import space from './modules/space'
import folder from './modules/folder'
import common from './modules/common'
import user from './modules/user'
import report from './modules/report'
import manager from './modules/manager'
import knowledge from './modules/knowledge'
import chome from './modules/chome'
import manage   from './modules/manage'
import category from './modules/category'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoggedIn: false,
        loadingCount: 0,
        leftCollapse:true,
        mini: null,
        drawer: null,
        searchKey: '',
        saveFilterData: [],
        analyFilterData: [],
        spaceFilterData: [],
        // https://jima-test.iprdb.com/CN/2016/1/78/images/201610390092.jpg
        //    baseUrl: 'https://jima-test.iprdb.com',//测试环境
        //    imgSearch: 'https://jima-test.iprdb.com/oss/img',//测试环境
        baseUrl: 'https://www.iprdb.com',//g60的地址
        imgSearch: 'https://www.iprdb.com/oss/img',//g60的地址
        // baseUrl: process.env.API_ROOT, 
        folderId: '',
        analyKey: [],
        analyStr: '',
        countryChange: false,
        folderUpdate: '',
        secondKey: '',
        fcKeyData: '',
        spaceSecondKey: '',
        analySecondKey: ''
    },
    getters: {
        isLoggedIn: (state) => {
            return state.isLoggedIn;  
        },
        loadingCount: (state) => {
            return state.loadingCount;
        },
        leftCollapse: (state) => {
            return state.leftCollapse;
        },
        mini: (state) => {
            return state.mini;
        },
        drawer: (state) => {
            return state.drawer;
        },
        filterData: (state) => {
            return state.saveFilterData
        },
        folderId: (state) => {
            return state.folderId
        }
    },
    mutations: {
        setLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;  
        },
        startLoading(state) {
            state.loadingCount += 1;
        },

        stopLoading(state) {
            state.loadingCount -= 1;
            if(state.loadingCount < 0) {
                state.loadingCount = 0;
            }
        },
        setLeftCollapse(state,isCollapse){
           state.leftCollapse = isCollapse;
        },
        setMenuMini(state,mini){
            state.mini = mini;
        },
        setMenuDraw(state,drawer){
            state.drawer = drawer;
        },
        setSearchKey(state, searchKey){
            state.searchKey = searchKey;
            if(searchKey) {
                sessionStorage.setItem('searchKey', searchKey)
            }
        },
        setFilterData(state, saveFilterData){
            state.saveFilterData = saveFilterData;
            if(saveFilterData.length>0) {
                sessionStorage.setItem('saveFilterData',JSON.stringify(saveFilterData))
            }else {
                sessionStorage.setItem('saveFilterData', '')
            }
        },
        setFcKeyData(state,fcKeyData) {
            state.fcKeyData = fcKeyData;
            if(fcKeyData) {
                sessionStorage.setItem('fcKeyData', fcKeyData)
            }
        },
        setAnalyFilter(state, analyFilterData){
            state.analyFilterData = analyFilterData;
            if(analyFilterData.length>0) {
                sessionStorage.setItem('analyFilterData',JSON.stringify(analyFilterData))
            }else {
                sessionStorage.setItem('analyFilterData', '')
            }
        },
        setSpaceFilter(state, spaceFilterData){
            state.spaceFilterData = spaceFilterData;
            if(spaceFilterData.length>0) {
                sessionStorage.setItem('spaceFilterData',JSON.stringify(spaceFilterData))
            }else {
                sessionStorage.setItem('spaceFilterData', '')
            }
        },
        setSpaceSecondKey(state,spaceSecondKey) {
            state.spaceSecondKey = spaceSecondKey;
            sessionStorage.setItem('spaceSecondKey',JSON.stringify(spaceSecondKey))
        },
        setAnalySecondKey(state,analySecondKey) {
            state.analySecondKey = analySecondKey;
            sessionStorage.setItem('analySecondKey',JSON.stringify(analySecondKey))
        },
        setFolderId(state, folderId) {
            state.folderId = folderId;  
        },
        setAnalyKey(state, analyKey) {
            state.analyKey = analyKey;  
        },
        setAnalyStr(state, analyStr) {
            state.analyStr = analyStr;  
        },
        setCountryChange(state, countryChange) {
            state.countryChange = countryChange;  
        },
        setFolderUpdate(state, folderUpdate) {
            state.folderUpdate = folderUpdate;  
        }
    },
    actions: {
    },
    modules: {
        widgets,
        search,
        analy,
        space,
        folder,
        common,
        user,
        report,
        chome,
        manage,
        category,
        manager,
        knowledge,
    }
});